const STORAGE_KEY = 'oab_setup_redirect_context';

function readStorage() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeStorage(value) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function setOabSetupRedirectContext({ questionId, answer, sourceUrl }) {
  writeStorage({
    questionId: questionId ?? null,
    answer: answer ?? null,
    sourceUrl: sourceUrl ?? null
  });
}

export function getOabSetupRedirectContext() {
  return readStorage();
}

export function clearOabSetupRedirectContext() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage unavailable */
  }
}

function normalizeQuestionId(value) {
  if (value == null || value === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function resolveOabSetupRedirectParams(fallbackQuestionId = null) {
  const ctx = getOabSetupRedirectContext() || {};

  return {
    questionId:
      normalizeQuestionId(ctx.questionId) ??
      normalizeQuestionId(fallbackQuestionId),
    answer: ctx.answer || null,
    sourceUrl: ctx.sourceUrl || null
  };
}
